// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"0f58852f","76":"ad3cda46","136":"08bec779","154":"0425a649","453":"36ed79f1","487":"a963c628","674":"0413c610","721":"56867d63"}[chunkId] + ".chunk.js";
};